import { apiFetch } from './api';

export interface AccountRow {
  id: string;
  name: string;
  slug: string;
  createdAt: string;
  disabledAt: string | null;
  siteCount: number;
  agentCount: number;
}

const base = '/api/admin/accounts';

export const listAccounts = () => apiFetch<{ accounts: AccountRow[] }>(base).then((r) => r.accounts);

export const createAccount = (name: string, slug: string) =>
  apiFetch<{ account: AccountRow }>(base, { method: 'POST', body: JSON.stringify({ name, slug }) });

export const setAccountDisabled = (id: string, disabled: boolean) =>
  apiFetch<{ account: AccountRow }>(`${base}/${id}`, { method: 'PATCH', body: JSON.stringify({ disabled }) });
